var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlights2 = function SvgHighlights2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "highlights2_svg__Group_1124",
    x: 0,
    y: 0,
    viewBox: "0 0 32.5 45.4",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".highlights2_svg__st2{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    id: "highlights2_svg__Path_8496",
    d: "M25.5 29.8v-.9c0-.5 0-.9-.1-1.4v-.1c-.1-2.8-1.4-10.6-11.7-23.6C3.4 16.9 2.1 24.7 2 27.5v.1c0 .5-.1.9-.1 1.4 0 7.3 5.3 13.2 11.8 13.2 2.5 0 4.9-.9 6.9-2.5-1.9-3-1-6.9 2-8.8.9-.7 1.9-1 2.9-1.1M4.7 32c-.7 0-1.4-.5-1.4-1.3 0-.7.5-1.3 1.2-1.4.7 0 1.4.5 1.4 1.3 0 .7-.5 1.3-1.2 1.4m3.5-13.6c-1 3-1.9 6-2.5 9.1-.1.4-.5.8-.9.8h-.3c-.6-.1-.9-.7-.8-1.2.6-3.2 1.5-6.3 2.6-9.4.2-.5.8-.8 1.3-.6s.8.8.6 1.3",
    style: {
      fill: "#aad4c8"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "highlights2_svg__Path_8497",
    d: "M6.2 17.7c-1.1 3.1-1.9 6.2-2.6 9.4-.1.6.2 1.1.8 1.2h.3c.4 0 .8-.4.9-.8.6-3.1 1.5-6.1 2.5-9.1.2-.5-.1-1.1-.6-1.3s-1.1.1-1.3.6",
    className: "highlights2_svg__st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "highlights2_svg__Path_8498",
    d: "M3.3 30.8c0 .7.7 1.3 1.4 1.2s1.3-.7 1.2-1.5c-.1-.7-.7-1.3-1.5-1.2-.7.1-1.2.7-1.1 1.5",
    className: "highlights2_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "highlights2_svg__Path_8499",
    d: "M27.4 27.4c-.1-3.1-1.6-11.7-12.9-25.7-.4-.4-1-.5-1.4-.1l-.1.1C1.6 15.7.2 24.3.1 27.4c0 .5-.1 1-.1 1.5C0 37.2 6.2 44 13.7 44c3 0 5.9-1.1 8.1-3 2.7 2.3 6.8 1.9 9.1-.8s1.9-6.8-.8-9.1c-.8-.7-1.7-1.1-2.7-1.4v-1c.1-.3.1-.8 0-1.3m-7.8 8.9c0 1.2.4 2.4 1 3.4-1.9 1.6-4.4 2.5-6.9 2.5-6.5 0-11.8-5.9-11.8-13.2 0-.5 0-.9.1-1.4v-.1c.1-2.8 1.4-10.6 11.7-23.6C24 17 25.4 24.8 25.4 27.5v.1c0 .5.1.9.1 1.4v.9c-3.3.2-5.9 3-5.9 6.4m9.8-1.1v2H27v2.4h-2v-2.4h-2.4v-2H25v-2.4h2v2.4z",
    style: {
      fill: "#616e7d"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "highlights2_svg__Path_8500",
    d: "M27.1 39.6v-2.4h2.4v-2h-2.4v-2.4h-2v2.4h-2.4v2h2.4v2.4z",
    className: "highlights2_svg__st2"
  })));
};
export default SvgHighlights2;